<script lang="ts">
    import card from 'src/components/main/about/components/players-can/card.png'
    import icon from 'src/components/main/about/components/players-can/icon.svg'
    import line from 'src/components/main/about/components/players-can/line.svg'
</script>

<section class="nft" style="--line:url({line})">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="intro-title d-lg-none">Players can</div>
                <div class="image"><img src="{card}" alt=""></div>
            </div>
            <div class="col-lg-6">
                <div class="intro-title d-none d-lg-block">Players can</div>
                <img src="{icon}" class="icon" alt="">
                <div class="caption">Withdraw LIS Bybit exchange, NEAR or Polygon wallets for deposits or trading.</div>
                <img src="{icon}" class="icon" alt="">
                <div class="caption">Get LIS token by completing daily quests or other in-game activities.</div>
                <img src="{icon}" class="icon" alt="">
                <div class="caption">Increase their income and progress in games by upgrading their Membership (Silver, Gold or Platinum)</div>
            </div>
        </div>
    </div>
</section>

<style>
    .nft {
        margin: -50px 0 150px;
        padding: 200px 0;
        position: relative;
        background: var(--line) no-repeat center;
    }

    .image {
        position: relative;
    }

    .image img {
        opacity: 0.88;
        position: relative;
        z-index: 2;
    }

    .image:after {
        content: "";
        width: 401px;
        height: 634px;
        position: absolute;
        left: 110px;
        border-radius: 15px;
        -webkit-backdrop-filter: blur(5px);
        backdrop-filter: blur(5px);
        z-index: 1;
    }

    .intro-title {
        font-family: 'Anton', sans-serif;
        font-size: 50px;
        font-weight: 400;
        color: white;
        margin: -10px 0 40px;
        line-height: 1.5;
        letter-spacing: 2px;
        position: relative;
    }

    .caption {
        margin: 20px 0 50px;
        color: white;
        font-size: 20px;
        line-height: 1.5;
        border-bottom: 1px solid #5b5e76;
        padding-bottom: 20px;
    }

    @media(max-width: 1400px) {
        .nft {
            background-size: contain;
            background-position: center 100px;
            margin: -50px 0 0;
        }

        .image img {
            max-width: 420px;
        }

        .image:after {
            width: 330px;
            height: 522px;
            left: 90px;
        }

        .caption {
            margin: 15px 0 30px;
            font-size: 18px;
            padding-bottom: 15px;
        }
    }

    @media(max-width: 1199px) {
        .nft {
            margin: -50px 0;
        }

        .image img {
            max-width: 100%;
        }

        .image:after {
            width: 333px;
            height: 530px;
            left: 92px;
        }

        .intro-title {
            font-size: 50px;
        }

        .image {
            width: 100%;
            margin: 100px 0 0 0;
            padding-right: 30px;
        }
    }

    @media(max-width: 991px) {
        .nft {
            margin: 70px 0;
            padding: 70px 0;
        }

        .image {
            width: 100%;
            margin: 0 0 40px;
            padding-right: 66px;
        }

        .image img {
            max-width: 400px;
            width: 100%;
            margin: 0 auto;
            display: block;
        }

        .image:after {
            width: 314px;
            height: 497px;
            left: 50%;
            top: 0;
            margin-left: -147px;
        }

        .intro-title {
            font-size: 50px;
            line-height: 1.3;
            margin: 0 0 80px;
            text-align: center;
        }
    }

    @media(max-width: 767px) {
        .nft {
            margin: 50px 0 0;
            padding: 50px 0 20px;
            background-size: 400%;
            background-position: -260px 50px;
        }

        .intro-title {
            font-size: 40px;
            margin-bottom: 70px;
        }

        .caption {
            font-size: 16px;
        }

        .image img {
            opacity: 0.9;
        }

        .image:after {
            display: none;
        }
    }
</style>
